/* istanbul ignore file */
export default function padStartZero(value: number | string): string {
  if (value === '') {
    return value;
  }

  const numberValue = typeof value === 'string' ? parseInt(value, 10) : value;

  if (numberValue > 9) {
    return numberValue.toString();
  }

  return numberValue.toString().padStart(2, '0');
}
